<template>
    <div id="index" ref="appRef">
        <div class="bg">
            <dv-loading v-if="loading">
                <div style="margin-top:5px;color:#fff">数据更新中，请稍后...</div>
            </dv-loading>
            <div v-else class="host-body">
                <div id="top-header">
                    <dv-decoration-1 class="dv-dec-10" />
                    <dv-decoration-5 class="header-center-decoration" :dur="5" :color="['#4cccda', '#4cccda']" />
                    <dv-decoration-1 class="dv-dec-10-s" />
                    <div class="center-title">大咖国际托盘数字化管理中心</div>
                    <div class="refresh" @click="btnRefresh()"><i class="el-icon-refresh"></i></div>
                </div>

                <div class="screen-content">
                    <div class="map">
                        <div class="content-bg">
                            <dv-decoration-12 style="width:850px;height:850px;" :color="['#4cccda', '#4cccda']" :scanDur="8" :haloDur="4" />
                        </div>
                        <dv-border-box-12 :dur="10" :color="['#4cccda', '#4cccda']">
                            <map-echart :screenData="screenData.map" />
                        </dv-border-box-12>
                    </div>

                    <div class="lineChart-content">
                        <div class="lineChart">
                            <dv-border-box-12 :color="['#4cccda', '#4cccda']">
                                <div class="echart-top">
                                    <div class="echart-title">大咖起退租数量统计</div>
                                    <el-date-picker ref="dknowDatePickerRef" class="echart-select" v-model="dkNowQueryParams.timeRange" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :popper-append-to-body="false" @change="onChangeDkNow">
                                    </el-date-picker>
                                </div>
                                <right-top :screenData="screenData.dkNowData" />
                            </dv-border-box-12>
                        </div>
                        <div class="lineChart">
                            <dv-border-box-12 :color="['#4cccda', '#4cccda']">
                                <div class="echart-top">
                                    <div class="echart-title">分仓流转数量统计</div>
                                    <el-date-picker ref="dkDownDatePickerRef" class="echart-select" v-model="dkDownQueryParams.timeRange" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :popper-append-to-body="false" @change="onChangeDkDown">
                                    </el-date-picker>
                                    <el-select ref="dkDownSelectRef" style="margin-left:10px;width:270px" v-model="dkDownQueryParams.memberId" clearable filterable placeholder="请选择区域" @change="onChangeDkDownMember">
                                        <el-option v-for="item in dkMemberList" :key="item.id" :label="item.name" :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                                <right-bottom :screenData="screenData.dkDownData" />
                            </dv-border-box-12>
                        </div>
                        <div class="table-content">
                            <dv-border-box-12 :color="['#4cccda', '#4cccda']">
                                <div class="echart-top">
                                    <div class="echart-title">分仓起退租数量</div>
                                    <el-date-picker ref="dkTableDatePickerRef" style="margin-left:20px;width:300px" class="echart-select" v-bind:picker-options="pickerOptions" v-model="dkTableQueryParams.timeRange" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="onChangeDkTable">
                                    </el-date-picker>
                                    <div class="downLoad" @click="btnDownLoad('dkDownStreamBeginStopBillingByPeriod')"><i class="el-icon-download"></i>下载</div>
                                </div>
                                <dk-table :swiperList="screenData.swiperList" />
                            </dv-border-box-12>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { formatTime } from "@/libs/utils/localUtil.js";
import useIndex from "@/libs/utils/useDraw.js";
import mapEchart from "./component/map/index.vue";
import rightTop from "./component/right-top/index.vue";
import rightBottom from "./component/right-bottom/index.vue";
import dkTable from "./component/dk-table/index.vue";

import {
    handleMonthData,
    handleDayData,
    handleBeforeYear,
    handleBefore30Day,
    sliceGroup,
    shortcuts,
} from "./component/handleData.js";

export default {
    name: "screen",
    components: { mapEchart, rightTop, rightBottom, dkTable },
    data() {
        return {
            intervalTime: null,
            intervalScreen: null,
            intervalRefresh: null,
            intervalLoading: null,
            loading: true,
            dkMemberList: [],
            screenData: {
                map: [],
                dkNowData: {
                    xLineList: [],
                    dataList: [],
                },
                dkDownData: {
                    xLineList: [],
                    upDataList: [],
                    reDataList: [],
                },
                swiperList: [],
            },
            dkNowQueryParams: {
                beginDate: "",
                endDate: "",
                timeRange: [],
            },
            dkDownQueryParams: {
                beginDate: "",
                endDate: "",
                timeRange: [],
                memberId: "",
            },
            dkTableQueryParams: {
                beginDate: "",
                endDate: "",
                timeRange: [],
            },
            pickerOptions: shortcuts(),
            loadRequest: "",
        };
    },

    mounted() {
        document.getElementsByClassName("contact")[0].style.display = "none";
        const { appRef, calcRate, windowDraw } = useIndex(this.$refs.appRef);
        windowDraw();
        calcRate();
        this.initTime();
        this.getDkMembers();
        this.cancelLoading();
        this.polling();
        this.refreshPath();
    },
    destroyed() {
        document.getElementsByClassName("contact")[0].style.display = "block";
        clearInterval(this.intervalTime);
        clearTimeout(this.intervalScreen);
        clearTimeout(this.intervalRefresh);
    },
    watch: {
        "dkNowQueryParams.timeRange"() {
            if (this.dkNowQueryParams.timeRange == null) {
                this.initTime();
                this.getDKNowBilling();
            }
        },
        "dkDownQueryParams.timeRange"() {
            if (this.dkDownQueryParams.timeRange == null) {
                this.initTime();
                this.getDKDownBilling();
            }
        },
        "dkTableQueryParams.timeRange"() {
            if (this.dkTableQueryParams.timeRange == null) {
                this.initTime();
                this.getDKTableData();
            }
        },
    },
    methods: {
        cancelLoading() {
            setTimeout(() => {
                this.loading = false;
            }, 500);
        },
        polling() {
            this.getMap();
            this.getDKNowBilling();
            this.getDKDownBilling();
            this.getDKTableData();
            this.intervalScreen = setTimeout(() => {
                clearTimeout(this.intervalScreen);
                this.polling();
            }, 300000);
        },
        refreshPath() {
            this.intervalRefresh = setTimeout(() => {
                clearTimeout(this.intervalRefresh);
                this.$router.go(0); // 刷新当前页
            }, 1800000);
        },
        getMap() {
            let data = {
                url: "http://MID-DATA-REPORT/messageService/reportService/queryDKProvinceContractSum",
                body: {},
            };
            this.invoke(data).then((res) => {
                this.screenData.map = res;
            });
        },
        // 查询大咖本身月度起退租统计(只需显示起租)
        getDKNowBilling() {
            let data = {
                url: "http://MID-DATA-REPORT/messageService/reportService/queryDKDateBeginStopBilling",
                body: this.dkNowQueryParams,
            };
            this.invoke(data).then((res) => {
                this.screenData.dkNowData = handleDayData(
                    this.dkNowQueryParams.beginDate,
                    this.dkNowQueryParams.endDate,
                    res,
                    "dkNow"
                );
            });
        },
        // 查询大咖下游月度起退租统计
        getDKDownBilling() {
            let data = {
                url: "http://MID-DATA-REPORT/messageService/reportService/queryDKDownStreamDateDeliverAndStop",
                body: this.dkDownQueryParams,
            };
            this.invoke(data).then((res) => {
                this.screenData.dkDownData = handleDayData(
                    this.dkDownQueryParams.beginDate,
                    this.dkDownQueryParams.endDate,
                    res,
                    "dkDown"
                );
            });
        },
        // 查询大咖表格
        getDKTableData() {
            let data = {
                url: "http://MID-DATA-REPORT/messageService/reportService/queryDKDownStreamBeginStopBillingByPeriod",
                body: {
                    param: this.dkTableQueryParams,
                },
            };
            this.invoke(data).then((res) => {
                var tableList = res;
                this.screenData.swiperList = sliceGroup(tableList, 6);
                if (tableList.length === 0) {
                    this.screenData.swiperList = [[]];
                }
            });
        },
        // 选择器回调
        onChangeDkNow(e) {
            this.dkNowQueryParams.beginDate = e[0];
            this.dkNowQueryParams.endDate = e[1];
            this.getDKNowBilling();
        },
        // 选择器回调
        onChangeDkDown(e) {
            this.dkDownQueryParams.beginDate = e[0];
            this.dkDownQueryParams.endDate = e[1];
            this.getDKDownBilling();
        },
        // 选择器回调
        onChangeDkDownMember() {
            this.getDKDownBilling();
        },
        // 选择器回调
        onChangeDkTable(e) {
            this.dkTableQueryParams.beginDate = e[0];
            this.dkTableQueryParams.endDate = e[1];
            this.getDKTableData();
        },
        initTime() {
            var timeList = handleBeforeYear();
            var time30List = handleBefore30Day();
            this.dkNowQueryParams.beginDate = time30List[1];
            this.dkNowQueryParams.endDate = time30List[0];
            this.dkNowQueryParams.timeRange = [time30List[1], time30List[0]];
            this.dkDownQueryParams.beginDate = time30List[1];
            this.dkDownQueryParams.endDate = time30List[0];
            this.dkDownQueryParams.timeRange = [time30List[1], time30List[0]];
            this.dkTableQueryParams.beginDate = time30List[1];
            this.dkTableQueryParams.endDate = time30List[0];
            this.dkTableQueryParams.timeRange = [time30List[1], time30List[0]];
        },
        // 获取参与人
        getDkMembers() {
            let data = {
                url: "http://MID-DATA-REPORT/messageService/reportService/queryDKDownStreamMembers",
                body: {},
            };
            this.invoke(data).then((res) => {
                this.dkMemberList = res;
            });
        },
        // 下载
        async btnDownLoad(id) {
            let params = {
                exportId: id,
                body: {},
            };
            params.body["param"] = JSON.parse(
                JSON.stringify(this.dkTableQueryParams)
            );
            await this.download("/export", params);
        },
        // 刷新
        async btnRefresh() {
            this.loading = true;
            let data = {
                url: "http://MID-DATA-REPORT/messageService/reportService/refreshDKData",
                body: {},
            };
            await this.invoke(data).then((res) => {
                this.loadRequest = res;
            });

            this.toRefreshLoading(this.loadRequest);
        },

        toRefreshLoading(loadRequest) {
            let data = {
                url: "http://MID-DATA-BATCH/messageService/batchService/queryProcessRuntime",
                body: {
                    runtimeId: loadRequest,
                },
            };
            this.invoke(data).then((res) => {
                if (res.status !== "FINISH") {
                    this.loading = true;
                    this.intervalLoading = setTimeout(() => {
                        this.toRefreshLoading(loadRequest);
                    }, 1000);
                } else {
                    this.loading = false;
                    clearTimeout(this.intervalLoading);
                    this.getMap();
                    this.getDKNowBilling();
                    this.getDKDownBilling();
                    this.getDKTableData();
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
@import "./component/index.scss";
</style>
